import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { TaskNameService } from '../task-name-service';
import { GetTaskDetail } from '@/infrastructure/api-functions/core-drafting-api/get-task-detail-api';
import { UpdateTaskNameApi } from '@/infrastructure/api-functions/core-drafting-api/update-task-name-api';
import { SpecificationModel } from '@/domains/specification/models/specification-model';

@injectable()
export class TaskNameServiceImpl implements TaskNameService {
    constructor(
        @inject(UpdateTaskNameApi)
        private readonly _updateTaskNameApi: UpdateTaskNameApi,
        @inject(GetTaskDetail)
        private readonly _getTaskDetailApi: GetTaskDetail<string>,
        @inject(SpecificationModel)
        private _model: SpecificationModel,
    ) {}

    async getTaskName(taskId: string): Promise<string> {
        const data = await this._getTaskDetailApi.getTaskDetail(taskId);
        if (data.wireframeExtractConfig) {
            this._model.update((state) => ({
                ...state,
                wireframeExtractConfig: {
                    enabled: data.wireframeExtractConfig?.enabled ?? false,
                    remainingCount: data.wireframeExtractConfig?.remainingCount ?? 0,
                    totalCount: data.wireframeExtractConfig?.totalCount ?? 0,
                },
            }));
        }
        return data.title;
    }

    setTaskName(taskId: string, taskName: string): Promise<void> {
        return this._updateTaskNameApi.updateTaskName({
            taskId,
            content: taskName,
        });
    }
}
